import { render, staticRenderFns } from "./UserRoiReport.vue?vue&type=template&id=0251ac0c&"
import script from "./UserRoiReport.vue?vue&type=script&lang=js&"
export * from "./UserRoiReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports